<template>
  <span>
    <button @click="triggerFileInput" class="btn btn-sm btn-carma ai-upload-button">
      <i class="fa fa-upload"></i> {{$t('ai_coding.form.buttons.upload_image')}}
    </button>
    <input 
      type="file" id="image" name="image" ref="image" 
      class="upload-file hidden" accept="image/*" 
      multiple @change="(e) => handleFileUpload(e, model)" 
    />
    <div v-if="model.images.length" class="d-flex">
      <div class="d-flex flex-wrap justify-content-start gap-2">
        <div 
          v-for="(image, index) in model.images" 
          :key="index" 
          class="ai-image-container position-relative"
        >
          <img :src="image.url" class="image" />
          <i class="fas fa-times-circle remove-icon btn-primary" @click="removeImage(index, model)"></i>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    model: {
      type: Object
    },
    handleFileUpload: {
      type: Function,
      required: true
    },
    removeImage: {
      type: Function,
      required: true
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.image.click();
    },

  }
}
</script>

<style scoped lang="scss">
  .ai-image-container {
    max-width: 108px; 
    max-height: 90px;
    border: 2px solid $smoke;
    padding: 3px;
    border-radius: 5px;
  }

  .ai-image-container img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .ai-upload-button {
    position: relative;
    top: -40px;
    max-width: 100px;
    margin-top: -3px !important;
  }
  .remove-icon {
    position: absolute;
    top: 3px;
    right: -15px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  
  .ai-image-container:hover .remove-icon {
    opacity: 1;
  }

</style>